import React from 'react';
import {
  ProfileListItem,
  ProfileListResponse,
  UserProfileTypes,
} from 'services/requests';
import { mapIndependentIraTypeValueToKey } from 'screens/IndependentIra/IraIndependentIra.utils';
import messages from './ProfileList.messages';
import styles from './ProfileList.module.css';

type Props = {
  otherAccounts?: ProfileListResponse;
  email?: string;
  currentType?: string;
};

const TYPES = Object.values(UserProfileTypes).map(mapIndependentIraTypeValueToKey);

const ProfileList = ({
  otherAccounts,
  email,
  currentType,
}: Props): JSX.Element | null => {
  const filteredAccountList: ProfileListItem[] | undefined = otherAccounts?.items.filter(
    (item) => TYPES.includes(item?.profileType) && item.profileType !== currentType,
  );

  const linkedAccount = ({ profileTypeTitle, iraNumber }: ProfileListItem) =>
    profileTypeTitle ? `${profileTypeTitle}${iraNumber ? ` #${iraNumber}` : ''}` : null;

  return !!filteredAccountList && filteredAccountList.length > 0 ? (
    <>
      <div className={styles.otherAccounts__divider} />

      <h1 className={styles.otherAccounts__title}>{messages.title}</h1>
      <span className={styles.otherAccounts__subtitle}>
        {messages.subtitle1}
        <span className={styles.otherAccounts__email}>{email}</span>
        {messages.subtitle2}
      </span>
      {filteredAccountList?.map((item) => (
        <span key={item.profileType} className={styles.otherAccounts__link}>
          {linkedAccount(item)}
        </span>
      ))}
    </>
  ) : null;
};
export default ProfileList;
